import { Button } from 'components/Button';
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Checkbox as MaterialCheckbox,
  FormControlLabel,
} from '@mui/material';

type IDialogCheckbox = {
  title: string;
  text: string;
  isOpen: boolean;
  onClose: () => void;
  deleteItem?: () => void;
  loadingDelete?: boolean;
  label?: string;
  onConfirm?: () => void;
  loading?: boolean;
};

export const DialogCheckBox: React.FC<IDialogCheckbox> = ({
  title,
  text,
  isOpen,
  onClose,
  loadingDelete,
  deleteItem,
  onConfirm,
  loading,
  label,
}) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(false);
  }, [isOpen]);

  const handleConfirm = () => {
    if (typeof onConfirm === 'function') {
      return onConfirm();
    }

    if (typeof deleteItem === 'function') {
      return deleteItem();
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pb: 0 }}>
        <Grid container spacing={2}>
          <Grid item>{text}</Grid>
          <Grid item>
            <FormControlLabel
              value={checked}
              checked={checked}
              labelPlacement={'end'}
              control={
                <MaterialCheckbox
                  inputProps={{ 'aria-label': 'controlled' }}
                  onChange={(_, value) => {
                    setChecked(value);
                  }}
                />
              }
              label={label || 'Eu concordo em excluir permanente.'}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Não
        </Button>

        <Button
          variant="text"
          disabled={!checked || loadingDelete || loading}
          onClick={handleConfirm}
        >
          Sim
          {loadingDelete || loading ? (
            <CircularProgress
              size="small"
              sx={{ width: 24, height: 24, ml: 2 }}
            />
          ) : null}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
